import {
  Alert,
  Box,
  CardMedia,
  Paper,
  Snackbar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from "uuid";
import botonRetiro from '../../../Web Mundo/boton1.png';
import deposit_bone from '../../../Web Mundo/deposit_bone.png';
import withdraw_bone from '../../../Web Mundo/withdraw_bone.png';
import axios from 'axios';
import { getCookie } from '../../../utils/getCookie';
import { rutas } from '../../../rutas/rutas';
import { useSelector } from 'react-redux';

const columns = [
  { id: 'usuario',  label: '👤 USERS',      minWidth: 120 },
  { id: 'posicion', label: '🏆 POSITION',   minWidth: 100 },
  { id: 'puntaje',  label: '💀 HUESO',      minWidth: 100 },
  { id: 'ticket',   label: '🎟️ TICKET',    minWidth: 120 },
];


export const Stake = () => {
  const { informacion: { dineroReal } } = useSelector(state => state.userSlice);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [usuario, setUsuario] = useState({});
  const [acumulador, setAcumulador] = useState(0);
  const [ticket, setTicket] = useState(0);
  const [disponible, setDisponible] = useState(0);
  const [cantidad, setCantidad] = useState('');
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState("Error");

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  const handleChange = (e) => {
    const v = e.target.value;
    setCantidad(v === '' ? '' : Number(v));
  };

  const handleChangePage = (_, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(Number(e.target.value));
    setPage(0);
  };

  const handleRetiroTicket = () => {
    const tokenJWT = getCookie('token');
    axios
      .get(rutas.retirarTicket, { headers: { token: tokenJWT } })
      .then(() => {
        setOpen(true);
        setError(false);
      })
      .catch(err => {
        setErrorText(err?.response?.data?.error);
        setOpen(true);
        setError(true);
      });
  };

  const handleRetiroTodo = () => {
    const num = Number(cantidad);
    if (!num || num <= 0) {
      setErrorText("Enter a valid amount to withdraw");
      setOpen(true);
      setError(true);
      return;
    }

    const ok = window.confirm(`Are you sure you want to withdraw ${num}? ⚠️ 50% will be burned at withdrawal.`);
    if (!ok) return;

    const tokenJWT = getCookie('token');

    axios.post(
      rutas.retiroStake,
      { cantidad: num, confirm: true },
      { headers: { token: tokenJWT, 'Content-Type': 'application/json' } }
    )
      .then(() => {
        handleMirar();
        setCantidad('');
        setOpen(true);
        setError(false);
      })
      .catch(err => {
        setErrorText(err?.response?.data?.error || err?.message || "Error");
        setOpen(true);
        setError(true);
      });
  };

  const deposito = () => {
    const tokenJWT = getCookie('token');
    const num = Number(cantidad);

    if (num <= 0 || num > Number(dineroReal)) {
      setErrorText("Invalid amount");
      setOpen(true);
      setError(true);
      return;
    }

    const ok = window.confirm(`Are you sure you want to deposit ${num}? ⚠️ When you withdraw later, 50% will be burned.`);
    if (!ok) return;

    axios.post(
      rutas.stakeIngreso,
      { cantidad: num },
      { headers: { token: tokenJWT, 'Content-Type': 'application/json' } }
    )
      .then(() => {
        handleMirar();
        setOpen(true);
        setError(false);
      })
      .catch(err => {
        setErrorText(err?.response?.data?.error || "Error");
        setOpen(true);
        setError(true);
      });
  };

  // ✅ Versión final: calcula ticket por usuario
  const handleMirar = () => {
    const tokenJWT = getCookie('token');
    axios
      .get(rutas.mirarStake, { headers: { token: tokenJWT } })
      .then(res => {
        if (!res.data?.stake) return;

        const total = res.data.stake.reduce((acc, s) => acc + (Number(s?.cantidad) || 0), 0);
        const poolTickets = Number(res.data.ticket?.cantidad || 0);

        const row = res.data.stake.map(({ nombre, posicion, cantidad }) => {
          const puntaje = Number(cantidad) || 0;
          const ticketsGanados = total > 0 ? (puntaje / total) * poolTickets : 0;
          return {
            usuario: nombre,
            posicion,
            puntaje,
            ticket: ticketsGanados.toFixed(2)
          };
        });

        setDisponible(Number(res.data.disponible?.cantidad || 0));
        setTicket(poolTickets);
        setAcumulador(total);
        setUsuario(res.data.userStake);
        setRows(row);
      })
      .catch(() => {});
  };

  useEffect(() => {
    handleMirar();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'right',
        alignItems: 'center',
        width: '100%',
        height: { xs: '100%', md: '93vh' },
        backgroundImage: `url(https://res.cloudinary.com/druu0mcam/image/upload/v1719339319/Dise%C3%B1o_sin_t%C3%ADtulo_56_htku49_qnv3i1.png)`,
        backgroundPosition: 'bottom',
        backgroundSize: 'cover'
      }}
    >

      {/* Tabla */}
<Paper sx={{ width: { xs: '95%', md: '38%' }, height: { xs: '40%', md: '80%' }, backgroundColor: 'rgba(255,255,255,0.1)' }}>
  <TableContainer sx={{ height: '90%', "&::-webkit-scrollbar": { display: "none" } }}>
    <Table stickyHeader>
      <TableHead>
        <TableRow>
          {columns.map((col) => (
            <TableCell
              key={uuidv4()}
              align="center"
              sx={{
                background: "#0E1314",
                color: "#00FFFF",
                fontWeight: "bold",
                textShadow: "0 0 8px #00FFFF",
                letterSpacing: "1px",
                fontSize: "1rem"
              }}
            >
              {col.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableBody>
        {rows
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row) => (
            <TableRow key={uuidv4()} hover>
              {columns.map((col) => (
                <TableCell
                  key={col.id}
                  align="center"
                  sx={{ background: "#1E292B", color: 'white' }}
                >
                  {row[col.id]}
                </TableCell>
              ))}
            </TableRow>
          ))}
      </TableBody>
    </Table>
  </TableContainer>

  <TablePagination
    rowsPerPageOptions={[10, 25, 100]}
    component="div"
    count={rows.length}
    rowsPerPage={rowsPerPage}
    page={page}
    onPageChange={handleChangePage}
    onRowsPerPageChange={handleChangeRowsPerPage}
  />
</Paper>


      {/* Panel derecho */}
      <Paper sx={{ width: { xs: '95%', md: '58%' }, height: { xs: '40%', md: '90%' }, backgroundColor: 'rgba(255,255,255,0.1)' }}>
        <Box sx={{ width: '100%', height: '100%', flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Typography sx={{ fontSize: '1.5rem', m: 1, textShadow: 'blue 1px 0 10px', fontWeight: '800' }}>
            <a target="_blank" rel="noreferrer" href="https://peakd.com/hive-131619/@bigdogbone/how-does-the-stake-of-the-bone-token-work-in-the-big-dog-bone-game-to-get-a-reward-ticket">
              How does it work ?
            </a>
          </Typography>
          <Typography sx={{ fontSize: '1.5rem', m: 1, textShadow: 'blue 1px 0 10px', fontWeight: '800' }}>
            Daily Pool - {ticket}
          </Typography>
          <Typography sx={{ fontSize: '1.5rem', m: 1, textShadow: 'blue 1px 0 10px', fontWeight: '800' }}>
            Ticket available to claim - {disponible > 0 ? String(disponible).substring(0, 6) : 0}
          </Typography>
          <Typography variant="h5" sx={{ m: 1, textShadow: 'blue 1px 0 10px', fontWeight: '800' }}>
            Participation in the Pool:{" "}
            {usuario?.cantidad > 0 ? ((usuario?.cantidad / acumulador) * 100).toFixed(2) : 0}% -{" "}
            {usuario?.cantidad ? ((usuario?.cantidad / acumulador) * ticket).toFixed(4) : 0}
          </Typography>

          <CardMedia component="img" sx={{ width: 280, cursor: 'pointer' }} image={botonRetiro} onClick={handleRetiroTicket} />
          <TextField
            onChange={handleChange}
            value={cantidad}
            type="number"
            inputProps={{ min: 0, step: 'any' }}
            sx={{ border: '1px solid white', width: 280, mt: 2 }}
            label="Deposit"
            variant="filled"
          />
          <CardMedia component="img" sx={{ width: 280, cursor: 'pointer', mt: 1 }} image={deposit_bone} onClick={deposito} />
          <CardMedia component="img" sx={{ width: 280, cursor: 'pointer', mt: 1 }} image={withdraw_bone} onClick={handleRetiroTodo} />
        </Box>

        <Stack spacing={2} sx={{ width: "100%" }}>
          <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
            {error ? (
              <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }} variant="filled">
                {errorText}
              </Alert>
            ) : (
              <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }} variant="filled">
                Success
              </Alert>
            )}
          </Snackbar>
        </Stack>
      </Paper>
    </Box>
  );
};
